import { useState, useEffect } from 'react';
import { Channel, ChannelStatus } from 'core/models/channel';

function usePublishState(status: ChannelStatus | undefined) {
    const [isStarted, setIsStarted] = useState<boolean>();

    useEffect(() => {
        if (!status) {
            setIsStarted(undefined);
        } else {
            setIsStarted(status.publishing);
        }
    }, [status]);

    return isStarted;
}

export function useChannelStatus(channel: Channel) {
    const [status, setStatus] = useState<ChannelStatus>();

    useEffect(() => {
        const listener = (status: ChannelStatus) => {
            setStatus(status);
        };

        channel.addStatusListener(listener);

        return () => {
            channel.removeStatusListener(listener);
        };
    }, [channel]);

    return usePublishState(status);
}
